// Mock data pro nabídku cateringu pro Wanzl Family Day 2026

export const eventInfo = {
  title: "Family Day 2026",
  client: "WANZL spol. s r.o.",
  date: "6. června 2026",
  time: "9:00 - 16:00",
  location: "Hněvotín 333, 783 47 Hněvotín u Olomouce",
  expectedGuests: 1000,
  contactPerson: {
    name: "Anna Pánková",
    position: "Personalista",
    email: "anna.pankova@wanzl.cz",
    phone: "+420 704 884 011"
  }
};

export const menuItems = {
  mainDishes: [
    {
      id: 1,
      name: "Kanadské hranolky Poutine",
      description: "Hranolky, trhané maso, salát coleslaw, červená cibule, smažená cibulka, BBQ omáčka, koktejlová omáčka",
      price: 210,
      weight: "200g",
      category: "Hlavní jídlo",
      vegetarian: false,
      image: "https://vseproakci.cz/wp-content/uploads/2025/04/VSE_PRO_AKCI_HRANOLKY_017-370x370.jpg"
    },
    {
      id: 2,
      name: "Quesadillas",
      description: "Zapečená tortilla s čedarem, mozzarellou, pomalu pečeným trhaným masem v al pastor marinádě. Podáváme se salsou Mexicana a smetanou. 🌱 Nabízíme 3 varianty: klasická, vegetariánská, bez lepku a laktózy.",
      price: 210,
      weight: "200g",
      category: "Hlavní jídlo",
      vegetarian: false,
      image: "https://vseproakci.cz/wp-content/uploads/2025/01/quesa.jpg",
      variants: ["klasická", "vegetariánská", "bez lepku a laktózy"]
    },
    {
      id: 3,
      name: "Smash Beef Burger",
      description: "Šťavnatý hovězí burger z irského masa s čedarem, zeleninou a domácí bulkou",
      price: 210,
      weight: "200g",
      category: "Hlavní jídlo",
      vegetarian: false,
      image: "https://vseproakci.cz/wp-content/uploads/2025/01/beef-burger-2.png"
    },
    {
      id: 4,
      name: "Grilovaná krkovička",
      description: "Marinovaná v naší speciální marinádě + příloha grenaile brambory",
      price: 199,
      weight: "250g",
      category: "Hlavní jídlo",
      vegetarian: false,
      image: "https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/y27d7jww_grilovana%20krkovicka.jpg"
    },
    {
      id: 5,
      name: "Grilované kuřecí prso",
      description: "Šťavné kuřecí prso marinované v bylinkách, opečené na grilu s lehkou medovou glazurou a s grilovanou zeleninou",
      price: 189,
      weight: "200g",
      category: "Hlavní jídlo",
      vegetarian: false,
      image: "https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/14h4prs9_grilovane%20kureci%20prso.jpg"
    },
    {
      id: 6,
      name: "Grilovaný hermelín",
      description: "Grilovaný hermelín, zeleninový salátek s medovo-hořčičným dresingem, brusinky + bagetka",
      price: 159,
      weight: "150g",
      category: "Hlavní jídlo",
      vegetarian: true,
      image: "https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/9t13ai9e_hermelin.jpg"
    }
  ],
  snacks: [
    {
      id: 7,
      name: "Párek v rohlíku",
      description: "",
      price: 50,
      weight: "80g",
      category: "Občerstvení",
      vegetarian: false,
      image: "https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/yurb3id6_parek%20v%20rohliku.png"
    },
    {
      id: 8,
      name: "Vařená kukuřice",
      description: "",
      price: 65,
      weight: "150g",
      category: "Občerstvení",
      vegetarian: true,
      image: "https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/6igmo933_varena%20kukurice.jpg"
    },
    {
      id: 9,
      name: "Hranolky s omáčkou",
      description: "Křupavé zlaté hranolky servírované s kečupem nebo domácí tatarskou omáčkou",
      price: 60,
      weight: "100g",
      category: "Občerstvení",
      vegetarian: true,
      image: "https://images.unsplash.com/photo-1518013431117-eb1465fa5752?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxjcmlzcHklMjBmcmVuY2glMjBmcmllcyUyMHdpdGglMjBkaXBwaW5nJTIwc2F1Y2UlMjBmb29kJTIwcGhvdG9ncmFwaHl8ZW58MHx8fHwxNzczMDQ3NTExfDA&ixlib=rb-4.1.0&q=85"
    }
  ],
  desserts: [
    {
      id: 10,
      name: "Točená zmrzlina",
      description: "Italská zmrzlina z profesionálního stroje Frigomat, různé příchutě",
      price: 50,
      weight: "120g",
      category: "Dezert",
      vegetarian: true,
      image: "https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/82cxqufp_Sni%CC%81mek%20obrazovky%202026-03-09%20v%C2%A010.29.13.png"
    }
  ]
};

export const beverages = [
  {
    id: 11,
    name: "Pivo Radegast 10°",
    description: "Čepované pivo Radegast desítka",
    price: 50,
    volume: "0.5l",
    category: "Nápoje",
    alcoholic: true
  },
  {
    id: 12,
    name: "Birell Pomelo & Grep",
    description: "Nealkoholické pivo s příchutí pomela a grepu",
    price: 50,
    volume: "0.5l",
    category: "Nápoje",
    alcoholic: false
  },
  {
    id: 13,
    name: "Točená limonáda",
    description: "Čerstvá točená limonáda různých příchutí",
    price: 40,
    volume: "0.5l",
    category: "Nápoje",
    alcoholic: false
  },
  {
    id: 14,
    name: "Voda PET",
    description: "Balená voda neperlivá/perlivá",
    price: 30,
    volume: "0.5l",
    category: "Nápoje",
    alcoholic: false
  },
  {
    id: 15,
    name: "Káva / Ledová káva / Frappé",
    description: "Kvalitní káva z mobilního baru",
    price: 60,
    volume: "0.1 - 0.3l",
    category: "Nápoje",
    alcoholic: false
  },
  {
    id: 16,
    name: "Prosecco",
    description: "Italské šumivé víno",
    price: 60,
    volume: "0.2l",
    category: "Nápoje",
    alcoholic: true
  }
];

export const overhead = [
  {
    id: "oh1",
    name: "Kompletní režie",
    description: "Zahrnuje: jednorázové obaly, cateringové vybavení (chafingy, ohřívače, kávovary, výčep), 2x Food truck, 2x Beer truck, 1x Bar truck, 2x Live cooking stanoviště, kompletní doprava (catering, personál, všechny trucky)",
    price: 50000,
    unit: "celkem na 1000 osob"
  }
];

export const transport = [];

export const personnel = [
  {
    id: "per1",
    name: "Kompletní personál",
    description: "3x Kuchař (290 Kč/hod), 3x Pomocný kuchař (250 Kč/hod), 4x Obsluha (200 Kč/hod), 5x Barman (250 Kč/hod). Odhad 10 odpracovaných hodin. Celková částka bude účtována na základě skutečně odpracovaných hodin na místě (příprava, průběh akce, úklid).",
    totalEstimated: 36700,
    unit: "celkem na 1000 osob (odhad)",
    breakdown: [
      { role: "Kuchař", count: 3, hourlyRate: 290, hours: 10 },
      { role: "Pomocný kuchař", count: 3, hourlyRate: 250, hours: 10 },
      { role: "Obsluha", count: 4, hourlyRate: 200, hours: 10 },
      { role: "Barman", count: 5, hourlyRate: 250, hours: 10 }
    ]
  }
];

export const galleryImages = [
  "https://vseproakci.cz/wp-content/uploads/Image3.png",
  "https://vseproakci.cz/wp-content/uploads/2025/04/VSE_PRO_AKCI_HRANOLKY_017.jpg",
  "https://vseproakci.cz/wp-content/uploads/Image10.png",
  "https://vseproakci.cz/wp-content/uploads/2025/01/food-truck-foto-toz-tacos-1-scaled.jpg",
  "https://vseproakci.cz/wp-content/uploads/Image11.png",
  "https://vseproakci.cz/wp-content/uploads/2025/01/bar-truck-1.jpg",
  "https://vseproakci.cz/wp-content/uploads/IMG_0952-370x370.jpg",
  "https://vseproakci.cz/wp-content/uploads/2025/05/IMG_6447-2-scaled.jpg",
  "https://vseproakci.cz/wp-content/uploads/IMG_0968-370x370.jpg",
  "https://vseproakci.cz/wp-content/uploads/2025/06/kontaktfest0811.jpg",
  "https://vseproakci.cz/wp-content/uploads/2025/01/mini-burger.jpg",
  "https://vseproakci.cz/wp-content/uploads/AMK1377.jpg"
];

export const companyInfo = {
  name: "všeproakci",
  fullName: "Vše pro akci s.r.o.",
  contact: {
    name: "Jakub Vodárek",
    position: "Jednatel",
    phone: "774 750 456",
    email: "info@vseproakci.cz"
  },
  website: "https://vseproakci.cz",
  logo: "https://vseproakci.cz/wp-content/uploads/2024/11/VPA-logo-white.png"
};

export const references = [
  {
    name: "Fatra a.s.",
    logo: "https://www.fatra.cz/images/logo.png",
    testimonial: "Bylo to fakt super. Všechno perfektně zorganizované a doladěné do posledního detailu."
  },
  {
    name: "Česká televize",
    logo: "https://www.ceskatelevize.cz/design/images/logo.png"
  },
  {
    name: "Amazon",
    logo: "https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg"
  },
  {
    name: "Barum Continental",
    logo: "https://www.continental.com/resource/image/286618/landscape_ratio16x9/1920/1080/7c6e3e25e6f78a5cdf8b9e1e2c3fbd0f/1CBAC48C6DA3BBDF2C2429E8F2C8D7A4/continental-logo-white-on-yellow.png"
  },
  {
    name: "Plzeňský Prazdroj",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/34/Plze%C5%88sk%C3%BD_Prazdroj_logo.svg/2560px-Plze%C5%88sk%C3%BD_Prazdroj_logo.svg.png"
  },
  {
    name: "KBP",
    logo: "https://www.kbp.cz/wp-content/uploads/2023/01/KBP_logo.png"
  },
  {
    name: "Greiner Packaging",
    logo: "https://www.greiner-gpi.com/fileadmin/gpi/images/greiner-packaging-logo.svg"
  }
];
